import XEUtils from "xe-utils";
import httpManager from "../../util/common";
import EntityTitle from '@/entity/components/EntityTitle'
import {entityOaid} from "../../util/util";

let patent_detail = {
  components: {EntityTitle},
  // props: ['oaid'],
  data: () => {
    return {
      data: [],
      oaid: null,
      start_date: null,
      end_date: null,
      ipc_code: null,
      citation_min: null,
      citation_max: null,
      sort_column: 'grant_date',
      sort_order: 'desc',
      loading: false,
      tableColumn: [
        {type: 'seq', width: 50},
        {title: 'i18n.patent.application_id', field: 'patent_id'},
        {title: 'i18n.patent.patent_name', field: 'patent_title'},
        {title: 'i18n.patent.application_date', field: 'application_date', sortable: true},
        {title: 'i18n.patent.granted_date', field: 'grant_date', sortable: true},
        {title: 'i18n.patent.validity_status', field: 'patent_status'},
        {title: 'i18n.patent.ipc_code', field: 'ipc_code'},
        {title: 'i18n.patent.number_of_claims', field: 'number_of_claims', sortable: true},
        {title: 'i18n.patent.priority_id', field: 'priority_no'},
        {title: 'i18n.patent.priority_date', field: 'priority_date'},
        {title: 'i18n.patent.numberof_patents_in_simple_family', field: 'number_of_simple_patent_family', sortable: true},
        {title: 'i18n.patent.simple_family_regions', field: 'simple_patent_family_country'},
        {title: 'i18n.patent.cited_times', field: 'number_of_forward_citation', sortable: true},
        {title: 'i18n.patent.current_patentee', field: 'patentee_name'}
      ],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      }
    }
  },
  methods: {
    // 排序按钮事件
    sortChangeEvent({ column, property, order }){
      this.sort_column=property
      this.sort_order=order
      this.page.currentPage=1
      if(!this.sort_order){
          this.sort_column=null
      }
      this.getPatentDetailData()
    },
    searchPatentDetailKeyUp (e) {
      if (e.$event.key === 'Enter') {
        this.getPatentDetailData()
      }
    },
    clearData () {
      this.data = []
      this.page.pageSize = 20
      this.page.currentPage = 1
      this.page.total = 0
      this.start_date = null
      this.end_date = null
      this.ipc_code = null
      this.citation_min = null
      this.citation_max = null
    },
    searchPatentDetailData () {
      this.getPatentDetailData()
    },
    pageChange ({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getPatentDetailData()
    },
    changeOaid () {
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid = result
        self.getPatentDetailData()
      })
    },
    getPatentDetailData () {
      let self = this
      if (self.oaid) {
        self.data = []
        self.loading = true
        let params = new Map()
        params.set('oaid', self.oaid)
        params.set('sort_column', self.sort_column)
        params.set('sort_order', self.sort_order)
        if (self.start_date) {
          params.set('start_date', self.start_date)
        }
        if (self.end_date) {
          params.set('end_date', self.end_date)
        }
        // if (self.ipc_code) {
        //   params.set('ipc_code', self.ipc_code)
        // }
        if (self.citation_min) {
          params.set('citation_min', self.citation_min)
        }
        if (self.citation_max) {
          params.set('citation_max', self.citation_max)
        }
        if (params.length === 0) {
          return
        }
        params.set('pagenum', self.page.currentPage)
        params.set('pagesize', self.page.pageSize)
        httpManager('patent_detail_info', params, null, null, null)
          .then(response => {
            self.data = response.data.data
            let page = response.data.page
            self.page.total = page.total
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.loading = false
          })
      }
    }
  },
  mounted () {
    this.changeOaid()
  },
  watch: {
    start_date: function () {
      this.page.currentPage = 1
      this.getPatentDetailData()
    },
    end_date: function () {
      this.page.currentPage = 1
      this.getPatentDetailData()
    }
  }
}
export default patent_detail



// WEBPACK FOOTER //
// ./src/patent/js/patent_detail.js